import { createContext, useContext } from 'react';
import type { AbuseScore } from '../../../services/types';

interface Props {
  children: JSX.Element[] | JSX.Element
  abuseScoring?: AbuseScore
}

export interface UserDataContextProps {
  abuseScoring?: AbuseScore | undefined
}

export const userDataContext = createContext<UserDataContextProps | undefined>(undefined);

export const useUserData = (): UserDataContextProps | undefined => useContext(userDataContext);

const UserDataWrapper = (props: Props): JSX.Element => {
  const { children, abuseScoring = 'low' } = props;

  return (
    <userDataContext.Provider value={{
      abuseScoring,
    }}
    >
      {children}
    </userDataContext.Provider>
  );
};

export default UserDataWrapper;
